<template>
	<div
		class="product-info"
		v-bind:class="{ border: showRightBorder }"
		@click="productClick"
	>
		<img class="product-icon" v-lazy="item.goods_img_480"/>
		<span class="product-title">{{ item.goods_name }}</span>
    <div class="product-bottom">{{ item.goods_promotion_price }}</div>
    <span class="product-moq">كمية المبيعات {{ item.goods_salenum }}</span>
	</div>
</template>
<script>
export default {
  name: 'IndexProductBody',
  data () {
    return {
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 == 0
    }
  },
  props: ['item', 'index'],
  computed: {

  },
  methods: {
    productClick: function () {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-content: flex-start;
  border: 0 solid #000;
  margin: 0;
  padding: 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
  width: 45.73333vw!important;
  margin-bottom: 5.33333vw;
  .product-icon {
    position: relative;
    justify-content: center;
    margin-bottom: 2.13333vw;
    width: 100%;
    height: 45.73333vw;
    overflow: hidden;
    border-radius: 2.13333vw;
    background-color: #f4f4f4;
    -o-object-fit: contain;
    object-fit: contain;
  }
  .product-title {
    display: -webkit-box;
    width: 100%;
    font-size: 3.46667vw;
    height: 8.53334vw;
    line-height: 4.26667vw;
    color: #666;
    margin-bottom: 1.2vw;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .product-bottom {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-weight: 700;
    font-size: 3.66667vw;
    color: #111;
    margin-bottom: 1.06667vw;
    line-height: 5.33333vw;
  }
}
.product-moq{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 3.46667vw;
  color: #888;
  margin-bottom: 3.2vw;
  line-height: 4.26667vw;
}
</style>